import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

const productFragment = `
 product {
      _id
      code
    }
`

export const myOrderListQuery = gql`
  query getMyOrderList($filter: JSON, $options: JSON) {
    getMyOrderList(filter: $filter, options: $options) {
      _id
      code
      net
      gross
      shippingFee
      createdAt
      status
      items {
        _id
        ${productFragment}
        quantity
        uom {
          _id
          code
          name
          symbol
        }
      }
      shipping {
        _id
        trackingUrl
        trackingNumber
      }
    }
    getMyOrderListMeta(filter: $filter) {
      count
    }
  }
`

export const buildQuery = (field) => buildGraphqlQuery('Order', `_id updatedAt ${field}`)
